import { orderBy } from 'lodash-es'

export default {
  computed: {
    filteredRoles() {
      let list = this.roles.filter(
        r => r.name !== 'Authenticated' && r.name !== 'Public' && r.name !== 'Teacher' && r.name !== 'Student'
      )
      list = orderBy(list, ['description', 'asc'])
      return list
    }
  }
}
